import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";

const settings = {
  dots: false,
  infinite: true,
  speed: 2500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2500,
  cssEase: "linear",
};

function OfferMenu2({ relatedProducts, setSelec }) {
  const dishListRefs = useRef({});
  const navRef = useRef(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState();
  const categoryRefs = useRef({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const visibleCategoryId = entry.target.id;
            setSelectedCategoryId(visibleCategoryId);

            const categoryElement = categoryRefs.current[visibleCategoryId];
            if (categoryElement && navRef.current) {
              const scrollX =
                categoryElement.offsetLeft - navRef.current.offsetLeft - 100;
              navRef.current.scroll({
                left: scrollX,
                behavior: "smooth",
              });
            }

            // Optional: Unobserve the current entry
            obs.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    // Observe elements
    Object.values(dishListRefs.current).forEach((el) => {
      if (el instanceof Element) observer.observe(el);
    });

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, [relatedProducts]);

  // useEffect(() => {
  //   // If a category is selected, scroll to it in the nav bar
  //   if (selectedCategoryId) {
  //     const categoryElement = categoryRefs.current[selectedCategoryId];
  //     if (categoryElement) {
  //       navRef.current.scrollLeft = categoryElement.offsetLeft - 100;
  //     }
  //   }
  // }, [selectedCategoryId]);

  return (
    <>
      <section className="row_am offer_menu_section" style={{ marginTop: 0 }}>
        <div className="container" style={{ padding: 0 }}>
          <ul
            className={`nav nav-tabs`}
            id="myTab"
            role="tablist"
            data-aos="fade-up"
            ref={navRef}
            draggable
            aria-orientation="horizontal"
            data-aos-duration={1500}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                overflowX: "scroll", // Enable horizontal scrolling
                whiteSpace: "nowrap", // Prevent wrapping to a new line
                padding: 0, // Corrected padding style
                overflowY: "hidden",
                WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS devices
                scrollbarWidth: "none" /* For Firefox */,
                msOverflowStyle: "none" /* For Internet Explorer 10+ */,
              }}
            >
              {relatedProducts
                ?.sort(
                  (a, b) =>
                    a?.categoryDetails?.order - b?.categoryDetails?.order
                )
                ?.map(({ categoryDetails }, index) => {
                  return (
                    <li
                      className="nav-item"
                      key={categoryDetails?._id}
                      style={{
                        display: "flex", // Ensures that items line up in a row
                        flexDirection: "row",
                      }}
                    >
                      <Link
                        ref={(el) =>
                          (categoryRefs.current[categoryDetails?._id] = el)
                        }
                        className={`nav-link ${
                          categoryDetails?._id ===
                          (selectedCategoryId
                            ? selectedCategoryId
                            : relatedProducts[0]?.categoryDetails?._id)
                            ? "active"
                            : ""
                        }`}
                        onClick={() => {
                          setSelectedCategoryId(categoryDetails?._id);
                          const element =
                            dishListRefs.current[categoryDetails?._id];
                          if (element) {
                            const elementRect = element.getBoundingClientRect();
                            const absoluteElementTop =
                              elementRect.top + window.pageYOffset;
                            const middle = absoluteElementTop - 100; // Subtract 100 pixels
                            window.scrollTo({
                              top: middle,
                              behavior: "smooth",
                            });
                          }
                          // Scroll the horizontal category list
                          const categoryElement =
                            categoryRefs.current[categoryDetails?._id];
                          if (categoryElement && navRef.current) {
                            const scrollX =
                              categoryElement.offsetLeft -
                              navRef.current.offsetLeft -
                              100;
                            navRef.current.scroll({
                              left: scrollX,
                              behavior: "smooth",
                            });
                          }
                        }}
                        id="lunch-tab"
                        data-toggle="tab"
                        to="#lunch"
                        role="tab"
                        aria-controls="lunch"
                        aria-selected="true"
                      >
                        {`${categoryDetails.name}`}
                      </Link>
                      <h2
                        style={{
                          marginLeft: "14px",
                          color: "#9a9a9a",
                        }}
                      >
                        {index !== relatedProducts?.length - 1 ? "|" : ""}
                      </h2>
                    </li>
                  );
                })}
            </div>
          </ul>
          <div
            className="tab-content"
            id="myTabContent"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            <div
              className="tab-pane fade show active"
              id="lunch"
              role="tabpanel"
              aria-labelledby="lunch-tab"
            >
              <div className="menulist_wraper">
                <div className="menulist left_side">
                  {relatedProducts
                    ?.slice(0, relatedProducts?.length / 2)
                    ?.map(({ categoryDetails, products }) => {
                      const category = categoryDetails?._id;
                      return (
                        <div
                          className="menulist_box"
                          key={category}
                          ref={(el) => (dishListRefs.current[category] = el)}
                          id={category}
                        >
                          <h3
                            className="menusub_text"
                            style={{ marginLeft: 10, marginRight: 10 }}
                          >
                            {categoryDetails?.name}
                          </h3>
                          <div data-aos="fade-up" data-aos-duration={1500}>
                            {categoryDetails?.images?.length > 0 && (
                              <div className="dish_img dish_left text-center">
                                <Slider {...settings}>
                                  {categoryDetails?.images?.map((image) => {
                                    return (
                                      <div>
                                        <LazyLoadImage
                                          alt={""}
                                          src={image}
                                          width={"100%"}
                                          style={{
                                            maxWidth:
                                              "100%" /* Ensures the image is not larger than its container */,
                                            maxHeight: 360 /* Maximum height */,
                                            display: "block",
                                          }}
                                        />
                                      </div>
                                    );
                                  })}
                                </Slider>
                              </div>
                            )}
                          </div>
                          <ul>
                            {products?.map((prod) => (
                              <li
                                key={prod?._id}
                                style={{ paddingLeft: 10, paddingRight: 10 }}
                              >
                                <div className="mainCource">
                                  <div className="dishName">
                                    <h4>{prod?.name}</h4>
                                    {!prod?.isAvailable ? (
                                      <span className="notAvailable">
                                        Not Available
                                      </span>
                                    ) : (
                                      prod?.isNew && (
                                        <span className="new">NEW</span>
                                      )
                                    )}
                                  </div>
                                  <div className="doted" />
                                  <span className="price">{`${prod?.currency}${prod?.price}`}</span>
                                </div>
                                <div className="description">
                                  <p>{prod?.description}</p>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      );
                    })}
                </div>
                <div className="menulist right_side">
                  {relatedProducts
                    ?.slice(
                      relatedProducts?.length / 2,
                      relatedProducts?.length
                    )
                    ?.map(({ categoryDetails, products }) => {
                      const category = categoryDetails?._id;
                      return (
                        <div
                          className="menulist_box"
                          key={category}
                          ref={(el) => (dishListRefs.current[category] = el)}
                        >
                          <h3
                            className="menusub_text"
                            style={{ marginRight: 10, marginLeft: 10 }}
                          >
                            {categoryDetails?.name}
                          </h3>
                          <div data-aos="fade-up" data-aos-duration={1500}>
                            {categoryDetails?.images?.length > 0 && (
                              <div className="dish_img dish_left text-center">
                                <Slider {...settings}>
                                  {categoryDetails?.images?.map((image) => {
                                    return (
                                      <div>
                                        <LazyLoadImage
                                          alt={""}
                                          src={image}
                                          width={"100%"}
                                          style={{
                                            maxWidth:
                                              "100%" /* Ensures the image is not larger than its container */,
                                            maxHeight: 360 /* Maximum height */,
                                            display: "block",
                                          }}
                                        />
                                      </div>
                                    );
                                  })}
                                </Slider>
                              </div>
                            )}
                          </div>
                          <ul>
                            {products?.map((prod) => {
                              if (!prod?.isHidden) {
                                return (
                                  <li
                                    key={prod?._id}
                                    style={{
                                      paddingLeft: 10,
                                      paddingRight: 10,
                                    }}
                                  >
                                    <div className="mainCource">
                                      <div className="dishName">
                                        <h4>{prod?.name}</h4>

                                        {!prod?.isAvailable ? (
                                          <span className="notAvailable">
                                            Not Available
                                          </span>
                                        ) : (
                                          prod?.isNew && (
                                            <span className="new">NEW</span>
                                          )
                                        )}
                                      </div>
                                      <div className="doted" />
                                      <span className="price">{`${prod?.currency}${prod?.price}`}</span>
                                    </div>
                                    <div className="description">
                                      <p>{prod?.description}</p>
                                    </div>
                                  </li>
                                );
                              } else {
                                return <></>;
                              }
                            })}
                          </ul>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OfferMenu2;

